<app-modal-base [title]="dialogTitle" [cancelType]="data.validateMode ? 'CANCEL' : 'CLOSE'"
  [hasSubmit]="data.validateMode" (onSubmitEvent)="docValidated()">
  <ng-container main *ngTemplateOutlet="content"></ng-container>
</app-modal-base>

<ng-template #content>
  <div mat-dialog-content>
    <div class="is-image" *ngIf="data.isImage; else iframeContent">
      <div class="loading">
        <div class="mb-2">Chargement en cours...</div>
        <div class="d-flex justify-content-center"><mat-spinner [diameter]="20" color="primary"></mat-spinner></div>
      </div>
      <img [src]="docUrl" />
    </div>
  </div>
</ng-template>

<ng-template #iframeContent>
  <div *ngIf="!iFrameLoaded && data.doRetry" class="loading">
    <div *ngIf="!iFrameError">
      <div class="mb-2">Chargement en cours...</div>
      <div class="d-flex justify-content-center"><mat-spinner [diameter]="20" color="primary"></mat-spinner></div>
    </div>
    <div *ngIf="iFrameError">
      <div>
        <p>Une erreur est survenue.</p>
        <p>Veuillez réessayer.</p>
      </div>
    </div>
  </div>
  <iframe #iframe [class]="iFrameClass" [src]="docUrl" (load)="onLoadIframe($event)">
  </iframe>
</ng-template>